import React from 'react';
import PropTypes from 'prop-types';
import { Form, Input, Table } from 'semantic-ui-react';
import i18next from 'i18next';

const AvailableDaysEditor = ({ object, onChange }) => {
    return (
        <Table basic collapsing unstackable style={{ width: '100%' }}>
            <Table.Body>
                {[1, 2, 3, 4, 5, 6, 7].map(day => {
                    const key = `day${day}Allowed`;
                    const value = object[key];
                    const hours = String(value).includes('-');

                    const dayRow = (
                        <Table.Row key={day}>
                            <Table.Cell>
                                {i18next.t('day' + day) + ':'}
                            </Table.Cell>
                            <Table.Cell>
                                <Form.Radio
                                    label={i18next.t('available')}
                                    checked={!!value && !hours}
                                    onChange={() => onChange(key, 'true')}
                                />
                            </Table.Cell>
                            <Table.Cell>
                                <Form.Radio
                                    label={i18next.t('unavailable')}
                                    checked={!value}
                                    onChange={() => onChange(key, null)}
                                />
                            </Table.Cell>
                            <Table.Cell>
                                <Form.Radio
                                    label={i18next.t('availableByTime')}
                                    checked={hours}
                                    onChange={() => onChange(key, '08:00-22:00')}
                                />
                            </Table.Cell>
                        </Table.Row>
                    );

                    if (hours) {
                        const from = String(value).split('-')[0];
                        const to = String(value).split('-')[1];

                        const hoursRow = (
                            <Table.Row key={'h' + day}>
                                <Table.Cell colSpan='4' style={{ borderTop: 0, paddingTop: 0, paddingBottom: 0 }}>
                                    <Form.Group widths='equal'>
                                        <span style={{ margin: 5 }}>
                                            {i18next.t('from')}
                                        </span>
                                        <Input
                                            type="time"
                                            value={from}
                                            required
                                            onChange={({ target }) => {
                                                onChange(key, `${target.value}-${to}`);
                                            }}
                                        />
                                        <span style={{ margin: 5 }}>
                                            {i18next.t('to')}
                                        </span>
                                        <Input
                                            type="time"
                                            value={to}
                                            required
                                            onChange={({ target }) => {
                                                onChange(key, `${from}-${target.value}`);
                                            }}
                                        />
                                    </Form.Group>
                                </Table.Cell>
                            </Table.Row>
                        );
                        return [dayRow, hoursRow];
                    }

                    return dayRow;
                })}
            </Table.Body>
        </Table>
    );
};

AvailableDaysEditor.propTypes = {
    onChange: PropTypes.func,
    object: PropTypes.object,

};

export { AvailableDaysEditor };